export enum companyType {
  EXISTING = 'EXISTING',
  CREATE = 'CREATE',
}
